import { useTranslation } from 'react-i18next'
import { getCountry } from 'react-international-phone'

import { wwtLog } from '@wwt/core/admin'
import { ReservationDto } from '@wwt/entities/api/search-response'

import { getYearsOldByBirthDate } from '../utils/getYearsOldByBirthDate'

export const useCustomerInformation = (reservation: ReservationDto) => {
	const { t } = useTranslation('reservation')

	const customer = t('reservationTab.guestInfo.adult.content', {
		name: reservation.name,
		lastName: reservation.lastName,
		ns: 'room-page',
		yearsOld: t('reservationTab.guestInfo.adult.yearOld', {
			count: getYearsOldByBirthDate(reservation.dateOfBirth),
			ns: 'room-page'
		})
	})

	const countryFromLib = getCountry({
		field: 'iso2',
		value: reservation.countryCode
	})?.name

	if (!countryFromLib) {
		wwtLog('Something went wrong with get country by countryCode')
	}

	const country = countryFromLib || reservation.countryCode

	const isBusinessTrip = t(
		`form.inputs.travellingOnBusiness.values.${
			reservation.isBusinessTrip ? 'yes' : 'no'
		}`
	)

	const gender =
		t(`form.inputs.gender.values.${reservation.gender}`) ||
		t('form.inputs.gender.values.DONT_ANSWER')

	return [
		{
			id: 1,
			title: t('reservationTab.customerInfo.customer', { ns: 'room-page' }),
			content: customer
		},
		{
			id: 2,
			title: t('form.inputs.email.title'),
			content: reservation.email
		},
		{
			id: 3,
			title: t('form.inputs.countryCode.title'),
			content: country
		},
		{
			id: 4,
			title: t('form.inputs.phone.title'),
			content: reservation.phone
		},
		{
			id: 5,
			title: t('form.inputs.gender.title'),
			content: gender
		},
		{
			id: 6,
			title: t('form.inputs.travellingOnBusiness.title'),
			content: isBusinessTrip
		},
		{
			id: 7,
			title: t('form.inputs.address.title'),
			content: reservation.address
		}
	]
}
